// source: pbtypes/vehicle/skills/actions/toggle_semantic_aim/toggle_semantic_aim.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = globalThis;

var pbtypes_gen_detection_detection_class_pb = require('../../../../../pbtypes/gen/detection/detection_class_pb.js');
goog.object.extend(proto, pbtypes_gen_detection_detection_class_pb);
var pbtypes_gen_semantic_aim_aim_mode_pb = require('../../../../../pbtypes/gen/semantic_aim/aim_mode_pb.js');
goog.object.extend(proto, pbtypes_gen_semantic_aim_aim_mode_pb);
goog.exportSymbol('proto.skills.ToggleSemanticAimActionArgs', null, global);
goog.exportSymbol('proto.skills.ToggleSemanticAimActionStateData', null, global);
goog.exportSymbol('proto.skills.ToggleSemanticAimResultData', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.skills.ToggleSemanticAimActionArgs = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.skills.ToggleSemanticAimActionArgs, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.skills.ToggleSemanticAimActionArgs.displayName = 'proto.skills.ToggleSemanticAimActionArgs';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.skills.ToggleSemanticAimResultData = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.skills.ToggleSemanticAimResultData, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.skills.ToggleSemanticAimResultData.displayName = 'proto.skills.ToggleSemanticAimResultData';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.skills.ToggleSemanticAimActionStateData = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.skills.ToggleSemanticAimActionStateData, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.skills.ToggleSemanticAimActionStateData.displayName = 'proto.skills.ToggleSemanticAimActionStateData';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.skills.ToggleSemanticAimActionArgs.prototype.toObject = function(opt_includeInstance) {
  return proto.skills.ToggleSemanticAimActionArgs.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.skills.ToggleSemanticAimActionArgs} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.skills.ToggleSemanticAimActionArgs.toObject = function(includeInstance, msg) {
  var f, obj = {
toggleOn: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
aimMode: jspb.Message.getFieldWithDefault(msg, 2, 0),
detectionClass: jspb.Message.getFieldWithDefault(msg, 3, 0),
numberFramesToAggregate: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.skills.ToggleSemanticAimActionArgs}
 */
proto.skills.ToggleSemanticAimActionArgs.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.skills.ToggleSemanticAimActionArgs;
  return proto.skills.ToggleSemanticAimActionArgs.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.skills.ToggleSemanticAimActionArgs} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.skills.ToggleSemanticAimActionArgs}
 */
proto.skills.ToggleSemanticAimActionArgs.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setToggleOn(value);
      break;
    case 2:
      var value = /** @type {!proto.semantic_aim.AimMode.Enum} */ (reader.readEnum());
      msg.setAimMode(value);
      break;
    case 3:
      var value = /** @type {!proto.detection.DetectionClass.Enum} */ (reader.readEnum());
      msg.setDetectionClass(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setNumberFramesToAggregate(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.skills.ToggleSemanticAimActionArgs.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.skills.ToggleSemanticAimActionArgs.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.skills.ToggleSemanticAimActionArgs} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.skills.ToggleSemanticAimActionArgs.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getToggleOn();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getAimMode();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getDetectionClass();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getNumberFramesToAggregate();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
};


/**
 * optional bool toggle_on = 1;
 * @return {boolean}
 */
proto.skills.ToggleSemanticAimActionArgs.prototype.getToggleOn = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.skills.ToggleSemanticAimActionArgs} returns this
 */
proto.skills.ToggleSemanticAimActionArgs.prototype.setToggleOn = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional semantic_aim.AimMode.Enum aim_mode = 2;
 * @return {!proto.semantic_aim.AimMode.Enum}
 */
proto.skills.ToggleSemanticAimActionArgs.prototype.getAimMode = function() {
  return /** @type {!proto.semantic_aim.AimMode.Enum} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.semantic_aim.AimMode.Enum} value
 * @return {!proto.skills.ToggleSemanticAimActionArgs} returns this
 */
proto.skills.ToggleSemanticAimActionArgs.prototype.setAimMode = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional detection.DetectionClass.Enum detection_class = 3;
 * @return {!proto.detection.DetectionClass.Enum}
 */
proto.skills.ToggleSemanticAimActionArgs.prototype.getDetectionClass = function() {
  return /** @type {!proto.detection.DetectionClass.Enum} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.detection.DetectionClass.Enum} value
 * @return {!proto.skills.ToggleSemanticAimActionArgs} returns this
 */
proto.skills.ToggleSemanticAimActionArgs.prototype.setDetectionClass = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional int64 number_frames_to_aggregate = 4;
 * @return {number}
 */
proto.skills.ToggleSemanticAimActionArgs.prototype.getNumberFramesToAggregate = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.skills.ToggleSemanticAimActionArgs} returns this
 */
proto.skills.ToggleSemanticAimActionArgs.prototype.setNumberFramesToAggregate = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.skills.ToggleSemanticAimResultData.prototype.toObject = function(opt_includeInstance) {
  return proto.skills.ToggleSemanticAimResultData.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.skills.ToggleSemanticAimResultData} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.skills.ToggleSemanticAimResultData.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.skills.ToggleSemanticAimResultData}
 */
proto.skills.ToggleSemanticAimResultData.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.skills.ToggleSemanticAimResultData;
  return proto.skills.ToggleSemanticAimResultData.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.skills.ToggleSemanticAimResultData} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.skills.ToggleSemanticAimResultData}
 */
proto.skills.ToggleSemanticAimResultData.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.skills.ToggleSemanticAimResultData.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.skills.ToggleSemanticAimResultData.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.skills.ToggleSemanticAimResultData} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.skills.ToggleSemanticAimResultData.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.skills.ToggleSemanticAimActionStateData.prototype.toObject = function(opt_includeInstance) {
  return proto.skills.ToggleSemanticAimActionStateData.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.skills.ToggleSemanticAimActionStateData} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.skills.ToggleSemanticAimActionStateData.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.skills.ToggleSemanticAimActionStateData}
 */
proto.skills.ToggleSemanticAimActionStateData.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.skills.ToggleSemanticAimActionStateData;
  return proto.skills.ToggleSemanticAimActionStateData.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.skills.ToggleSemanticAimActionStateData} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.skills.ToggleSemanticAimActionStateData}
 */
proto.skills.ToggleSemanticAimActionStateData.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.skills.ToggleSemanticAimActionStateData.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.skills.ToggleSemanticAimActionStateData.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.skills.ToggleSemanticAimActionStateData} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.skills.ToggleSemanticAimActionStateData.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};


goog.object.extend(exports, proto.skills);
